import { render, staticRenderFns } from "./AllTaskList.vue?vue&type=template&id=1c06f642&"
import script from "./AllTaskList.vue?vue&type=script&lang=js&"
export * from "./AllTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports